import { formatPercent } from '@shared/helpers/format-currency';
import { effectivePrice, type Product, packMargin } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const MarginPercentage: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Margin %',
  minWidth: 60,
  accessorFn: (product) => formatPercent(packMargin(product) / effectivePrice(product)),
  toCSV: (product) => ({
    'Margin %': (packMargin(product) / effectivePrice(product)).toFixed(2),
  }),
  gloss: 'Profit on one pack, as a percentage of the selling price.',
});
